import { render, staticRenderFns } from "./shareViewDetail.vue?vue&type=template&id=333c6bb1&scoped=true&"
import script from "./shareViewDetail.vue?vue&type=script&lang=js&"
export * from "./shareViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./shareViewDetail.vue?vue&type=style&index=0&id=333c6bb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333c6bb1",
  null
  
)

export default component.exports